export default __webpack_public_path__ + "static/media/kweak_l.f88c64b6.jpg";